package com.upcominds.expedite.data.auth

actual fun platformOidcConfig(issuer: String): OidcConfig = AuthConfigProvider.webConfig(issuer)
